<template>
    <v-card class="elevation-1 rounded-4">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold primary--text">{{action}}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog" :disabled="loading">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>

        <!-- picture preview -->
        <v-layout row wrap class="mt-10">
            <v-flex xs12>
                <div v-show="!clockInOutPic" class="attendance-pic" @click="showTakePic">
                    <p class="attendance-no-pic">
                        <u>Take {{action}} picture</u><br>
                        <v-icon large>photo_camera</v-icon>
                    </p>
                </div>
                <div v-show="clockInOutPic">
                    <v-img ref="attendancePic" @click="showTakePic" class="attendance-img" title="Click image to take picture again"></v-img>
                </div>
            </v-flex>
        </v-layout>

        <!-- shift, date/time, devic -->
        <v-layout row class="row-section">
            <v-flex xs12>
                <div class="text-xs-center">
                    <v-chip :style="`background-color:${workshiftColor}`">
                        <v-icon class="mr-5" title="Workshift">date_range</v-icon>
                        {{workshift}}
                    </v-chip>
                    <v-chip>
                        <v-icon class="mr-5" :title="`${action} Date and Time`">schedule</v-icon>
                       {{ clockInOutDate | moment("h:mm:ss A • ddd, MMM D") }}
                    </v-chip>
                    <v-chip>
                        <v-icon class="mr-5" :title="`${action} Device`">devices</v-icon>
                        {{ device }}
                    </v-chip>
                </div>
                <div class="text-xs-left mt-10" v-if="showComment">
                    <v-textarea v-model="remarks" label="Add comment" rows="1" color="primary"></v-textarea>
                </div>
            </v-flex>   
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn icon @click="showComment=!showComment" title="Add Comment">
                <v-icon>comment</v-icon>
            </v-btn>
            <v-btn color="primary" class="mr-20" @click="clockInOutCheck()" :disabled="!canClockInOut" :loading="loading">
                <v-icon class="mr-5">timer</v-icon>{{action}}
            </v-btn>
        </v-card-actions>

        <v-dialog v-model="dialogTakePic" fullscreen hide-overlay transition="dialog-bottom-transition">   
            <take-picture ref="takePicRef" @send="takePicHandler" :dialogTakePic.sync="dialogTakePic"></take-picture>
        </v-dialog>
        <v-dialog v-model="dialogNoPic" width="500">
            <v-card class="elevation-1 rounded-4"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">CONFIRM</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogNoPic=false" >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="text-xs-center">{{ action }} with no picture?</div><br>
                </v-card-text>
                 <v-divider></v-divider>
                 <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="warning" @click="clockInOut">Continue with no pic</v-btn>
                    <v-btn class="primary" @click="showTakePic">Take picture</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import myAttendanceApi from '@/api/myattendance'

export default {
    components: {
        'take-picture': () => import('@/components/Attendance/TakePicture'),
    },
    data() {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            workShiftId: null,
            workshift: null,
            workshiftColor: null,
            clockInOutDate: null, //for display on UI only. Actual date/time will be pulled from server/db
            clockInOutPic: null,
            clockInOutPicRequired: false,
            transDate: null,
            device: null,
            remarks: null,
            action: null,
            canClockInForNextDay: null,
            increment_timer: null,
            dialogTakePic: false,
            dialogNoPic: false,
            showComment: false
        }
    },
    methods: {
        clockInOutCheck() {
            if (!this.clockInOutPic) {
                this.dialogNoPic = true
            }else{
               this.clockInOut()
            }
        },
        clockInOut() {
            if (this.action == 'Clock-In') this.clockIn()
            else this.clockOut()
        },
        async clockIn() {
            try {
                this.loading = true
                var data = {
                    clockInDevice : this.device,
                    clockInRemarks : this.remarks,
                    clockInImage : this.clockInOutPic,
                    workShiftId : this.workShiftId,
                    clockInAddress: "",
                    canClockInForNextDay: this.canClockInForNextDay
                }
                const response = await myAttendanceApi.clockIn(data);
                if (response && response.status == 200) {
                    this.$emit('send', null)
                }
                this.loading = false
                this.closeDialog()
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async clockOut() {
            try {
                this.loading = true
                var data = {
                    clockOutDevice : this.device,
                    clockOutRemarks : this.remarks,
                    clockOutImage : this.clockInOutPic,
                    clockOutAddress: ""
                }
                const response = await myAttendanceApi.clockOut(data);
                if (response && response.status == 200) {
                    this.$emit('send', null)
                }
                this.loading = false
                this.closeDialog()
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        takePicHandler(base64Img) {
            this.clockInOutPic = base64Img
            this.$refs.attendancePic.src = base64Img
        },
        async showTakePic() {
            this.dialogNoPic = false
            const action = this.action.replace('-','').toString().toLowerCase()
            this.$refs.takePicRef.turnOnVideo(action)
            this.dialogTakePic = true
        },
        setParams(data) {
            this.clearForm()
            this.action = data.action
            this.workShiftId = data.workShiftId
            this.workshift = data.workshift
            this.workshiftColor = data.workshiftColor
            this.clockInOutDate = data.clockInOutDate 
            this.device = data.device
            this.clockInOutPicRequired = data.clockInOutPicRequired
            this.canClockInForNextDay = data.canClockInForNextDay
        },
        clearForm() {
            this.addRemarks = false
            this.remarks = null
            this.clockInOutPic = null
            this.error = false
            this.loading = false
        },
        incrementTime() {
            this.clockInOutDate = this.$moment(this.clockInOutDate).add(1, 'seconds')
        },
        closeDialog() {
            this.$emit('update:dialogClockInOut', false)
        }
    },
    created() {
        this.increment_timer = setInterval(this.incrementTime, 1000)
    },
    computed: {
        canClockInOut() {
            return !this.clockInOutPicRequired || !!this.clockInOutPic
        }
    },
    destroyed() {
        clearInterval(this.increment_timer)
    }
}
</script>
<style scoped>
.row-section {
    padding:5px 30px 5px 30px;
}
.row-section div {
    margin-top: 2px;
}
.attendance-pic {
    border-radius: 5px;
    height: 180px;
    border: 1px solid grey;
    margin: 10px auto 10px auto;
    display: block;
    width: 50%;
    cursor: pointer;
    overflow: hidden; /* Hide any overflow content */
}
.attendance-img {
    max-width: 60%;
    width: 60%;
    height: auto;
    border-radius: 4px;
    margin: auto;
    text-align:center;
    cursor: pointer;
}

.attendance-no-pic {
    text-align:center;
    padding: 70px 0;
    font-weight: bold;
}
</style>